import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=7c4ba793&lang=pug&"
import script from "./Release.vue?vue&type=script&lang=js&"
export * from "./Release.vue?vue&type=script&lang=js&"
import style0 from "./Release.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4ba793')) {
      api.createRecord('7c4ba793', component.options)
    } else {
      api.reload('7c4ba793', component.options)
    }
    module.hot.accept("./Release.vue?vue&type=template&id=7c4ba793&lang=pug&", function () {
      api.rerender('7c4ba793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Release.vue"
export default component.exports